module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/banner_six-76605c.png";